import axiosInstance from '../utils/axiosInstance';
import Cookies from 'js-cookie';
import { showAlert } from '../components/common/toastify/ToastContainer';
import { handleApiError } from '../lib/handleApiError';
import { jwtDecode } from 'jwt-decode';

export const login = async (credentials) => {
  try {
    const response = await axiosInstance.post(
      '/SmartProAPI/api/auth/authenticate',
      credentials,
      { timeout: 10000 },
    );
    const decoded = jwtDecode(response.data.token);
    const expiryDate = new Date(decoded.exp * 1000);
    Cookies.set('token', response.data.token, {
      expires: expiryDate,
      path: '/',
    });
    return decoded;
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      handleApiError('error', 'Request Timeout', error?.response?.status);
      throw error;
    }
    handleApiError(error, 'Login failed', error?.response?.status);
  }
};

export const logout = async () => {
  try {
    const res = await axiosInstance.post('/SmartProAPI/api/auth/logout');
    showAlert('update', 'Logout Successfully');
    Cookies.remove('token', { path: '/' });
  } catch (error) {
    handleApiError(error, 'Logout failed', error?.response?.status);
  }
};

export const getAccess = async () => {
  try {
    const res = await axiosInstance.get(
      '/SmartProAPI/api/role-menu-submenu-accesses',
    );
    return res.data.accessControl || [];
  } catch (error) {
    handleApiError(error, 'Failed to get access', error?.response?.status);
  }
};

export const checkSession = () => {
  const token = Cookies.get('token');

  if (!token) {
    return false;
  }

  const decoded = jwtDecode(token);
  const expiryTime = decoded.exp * 1000;
  const currentTime = Date.now();

  if (currentTime >= expiryTime) {
    import('sweetalert2').then((Swal) => {
      Swal.default
        .fire({
          title: 'Session Expired',
          text: 'Your session has expired. Please log in again.',
          icon: 'warning',
        })
        .then(() => {
          Cookies.remove('token');
        });
    });
    return false;
  } else {
    return true;
  }
};
